import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

/** Accent of the optional status icon shown above the card title. */
export type AuthShellIconTone = 'primary' | 'success' | 'danger';

/**
 * Centered-card authentication frame (CoreUI "authentication" demo layout) shared by every
 * public auth screen: logo on top, one card with title/subtitle, footer links below.
 * Card body goes in the default slot; the "Já tem uma conta?"-style line goes in `[authShellFooter]`.
 */
@Component({
  imports: [NgOptimizedImage, RouterLink],
  selector: 'app-auth-shell',
  templateUrl: './auth-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'auth-shell-host',
  },
})
export class AuthShellComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>('');
  readonly icon = input<string>('');
  readonly iconTone = input<AuthShellIconTone>('primary');
}
